import Layout from '@/layout/index.vue'

export const ActeAditionaleGrupareContracteRoute =
    {
      path: '/acte-aditionale-acord-cadru',
      component: Layout,
      redirect: '/acte-aditionale-acord-cadru',
      children: [
        {
          path: 'view/:actAditionalGrupareContracteID',
          component: (): Promise<any> =>
            import(/* webpackChunkName: "acte-aditionale" */ '@/features/acte-aditionale-grupare-contracte/views/details.vue'),
          name: 'ActAditionalGrupareContracteDetailsRoute',
          meta: {
            title: 'Detalii act adițional',
            requiresAuth: true
          }
        },
        {
          path: 'create/:grupareContracteId',
          component: (): Promise<any> =>
            import(
              /* webpackChunkName: "acte-aditionale-create" */
              '@/features/acte-aditionale-grupare-contracte/views/create-update-act.vue'),
          name: 'CreateActAditionalForGrupareContracteRoute',
          meta: {
            title: 'Adăugare act adițional',
            requiresAuth: true,
            action: 'create'
          }
        },
        {
          path: 'update/:actAditionalGrupareContracteId',
          component: (): Promise<any> =>
            import(
              /* webpackChunkName: "acte-aditionale-update" */
              '@/features/acte-aditionale-grupare-contracte/views/create-update-act.vue'),
          name: 'UpdateActAditionalForGrupareContracteRoute',
          meta: {
            title: 'Modificare act adițional',
            requiresAuth: true,
            action: 'update'
          }
        }
      ]
    }
